const STORAGE_KEY = 'interpals.modAction.pending';
const MAX_PENDING_AGE_MS = 24 * 60 * 60 * 1000;
const REQUEST_KEY_FIELD = 'idempotency_key';
const COMPLETION_QUERY_FIELD = 'mod_action_completed';

function browserStorage() {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
}

function pendingRequests(storage, now) {
    if (!storage) {
        return null;
    }

    try {
        const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(parsed)
            ? parsed.filter((request) => (
                request
                && typeof request.intent === 'string'
                && typeof request.requestId === 'string'
                && now - Number(request.createdAt) < MAX_PENDING_AGE_MS
            ))
            : [];
    } catch {
        return null;
    }
}

function writePending(storage, requests) {
    if (!storage) {
        return;
    }

    try {
        storage.setItem(STORAGE_KEY, JSON.stringify(requests));
    } catch {
        // The hidden request field still protects the current page.
    }
}

function requestIntent(entries, scope) {
    return JSON.stringify([
        String(scope),
        entries
            .filter(({name}) => ![REQUEST_KEY_FIELD, 'csrf_token'].includes(name))
            .map(({name, value}) => [String(name), String(value)]),
    ]);
}

function randomRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }

    return `mod-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

function suppliedRequestId(entries) {
    const entry = entries.find(({name}) => name === REQUEST_KEY_FIELD);
    const requestId = entry ? String(entry.value).trim() : '';
    return /^[A-Za-z0-9][A-Za-z0-9._:-]{15,63}$/.test(requestId) ? requestId : null;
}

export function claimModerationAction(
    entries,
    scope,
    storage = browserStorage(),
    createRequestId = randomRequestId,
    now = Date.now(),
) {
    const intent = requestIntent(entries, scope);
    const requests = pendingRequests(storage, now);
    const supplied = suppliedRequestId(entries);
    if (requests === null) {
        return {requestId: supplied || createRequestId()};
    }
    const pending = requests.find((request) => request.intent === intent);
    if (pending) {
        return {requestId: pending.requestId};
    }

    const requestId = createRequestId();
    requests.push({intent, requestId, createdAt: now});
    writePending(storage, requests);

    return {requestId};
}

export function completeModerationAction(requestId, storage = browserStorage()) {
    const now = Date.now();
    const requests = pendingRequests(storage, now);
    if (requests === null) {
        return;
    }
    writePending(
        storage,
        requests.filter((request) => request.requestId !== requestId),
    );
}

export function settleModerationAction(claim, status, storage = browserStorage()) {
    if (claim && status > 0 && status < 500 && status !== 409) {
        completeModerationAction(claim.requestId, storage);
    }
}

window.ModActionIdempotency = {
    claim: claimModerationAction,
    complete: completeModerationAction,
    settle: settleModerationAction,
    requestKeyField: REQUEST_KEY_FIELD,
};

try {
    const currentUrl = new URL(window.location.href);
    const completedRequestId = currentUrl.searchParams.get(COMPLETION_QUERY_FIELD);
    if (completedRequestId) {
        completeModerationAction(completedRequestId);
        currentUrl.searchParams.delete(COMPLETION_QUERY_FIELD);
        window.history.replaceState(window.history.state, '', currentUrl.toString());
    }
} catch {
    // A malformed location must not prevent moderation controls from loading.
}
